import { render, staticRenderFns } from "./DiscountModal.vue?vue&type=template&id=70f8a910&scoped=true&"
import script from "./DiscountModal.vue?vue&type=script&lang=js&"
export * from "./DiscountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8a910",
  null
  
)

export default component.exports